import { DocumentsState } from './documents.state';

export const DocumentState = [DocumentsState];

export * from './documents.actions';
export * from './documents.state';
